// src/components/ActivityIndicator.jsx

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaEye, FaRunning, FaLaptopCode } from 'react-icons/fa';

const icons = [
  { component: FaEye, key: 'watching' },
  { component: FaRunning, key: 'running' },
  { component: FaLaptopCode, key: 'working' },
];

const ActivityIndicator = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % icons.length);
    }, 1500); // Cycle icon every 1.5 seconds

    return () => clearInterval(interval);
  }, []);

  const IconComponent = icons[index].component;

  return (
    <div className="flex items-center gap-2 rounded-full border border-blue-700/60 bg-blue-900/50 px-3 py-1">
      {/* Animated Icon Wrapper */}
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={icons[index].key}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.3 }}
        >
          <IconComponent className="text-zinc-300" />
        </motion.div>
      </AnimatePresence>

      <span className="text-xs font-medium text-blue-300">Active</span>

      <div className="h-2 w-2 animate-pulse rounded-full bg-blue-400"></div>
    </div>
  );
};

export default ActivityIndicator;

//   {
//     text: 'Running',
//     Icon: FaRunning,
//     textColor: 'text-blue-300',
//     bgColor: 'bg-blue-900/50',
//     borderColor: 'border-blue-700/60',
//     pulseColor: 'bg-blue-400',
//   },
